import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import {
    GetBillingMilestones,
    GetTimeEntriesByActivities,
    GetTimeEntriesByTypologies,
} from './dashboard.state';

export const dashboardBillingGuard: CanActivateFn = (
    next: ActivatedRouteSnapshot,
): boolean | UrlTree => {
    const store = inject(Store);
    store.dispatch([new GetBillingMilestones({})]);
    return true;
};

export const dashboardTimesheetGuard: CanActivateFn = (
    next: ActivatedRouteSnapshot,
): boolean | UrlTree => {
    const store = inject(Store);
    store.dispatch([new GetTimeEntriesByActivities({}), new GetTimeEntriesByTypologies({})]);
    return true;
};
